<template>
  <div class="mask">
    <div
      class="mask__main"
      v-show="visible"
      :style="{width: Window_Size.width + 'px',height: Window_Size.height + 'px'}"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    visible: Boolean,
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'Window_Size',
      'TOOL'
    ])
  }
}
</script>

<style lang="scss" scoped>
.mask {
  &__main {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(#000, 0.75);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/logoutMask.vue